import moment from 'moment';
import templateUrl from './work-order-payout-report.component.html';
import { JobStatus } from '../../../../../core/enum/job-status';
import { RogersReportJobDetailsModal } from '../../rogershistory/rogers-report-history-details-modal.component';
import { interval } from 'rxjs';
import { exhaustMap, take } from 'rxjs/operators';
//import { ReportHistoryDetailsModal } from '../../../../report-jobs/report-details-modal.component';
//import { JobStatus } from '../../../../core/enum/job-status';

export const WorkOrderPayoutReportComponent = {
    controller: WorkOrderPayoutReportController,
    controllerAs: "vm",
    templateUrl
};

function WorkOrderPayoutReportController($q, $uibModal, apexApiUrl, divisionService,
    icdCorporationService, postedPayoutService, utilityService, rogersPayoutReportService,
    productOrderAdjustmentService) {
    'ngInject';
    const vm = this;

    vm.jobs;
    vm.JobStatus = JobStatus;
    vm.$onInit = onInit;
    vm.divisions;
    vm.filters = {};
    vm.icdCorporations;
    vm.onAddWorkOrder = onAddWorkOrder;
    vm.onExport = onExport;
    vm.onExportBackground = onExportBackground;
    vm.createPayoutReportInBackground = createPayoutReportInBackground;
    vm.onRefreshData = onRefreshData;
    vm.onRefreshDataInBackground = onRefreshDataInBackground;
    vm.onPostPayout = onPostPayout;
    vm.onSaveAdjustments = onSaveAdjustments;
    vm.onCancelAdjustments = onCancelAdjustments;
    vm.onChangeDivision = onChangeDivision;
    vm.onChangeAdjustmentAmount = onChangeAdjustmentAmount;
    vm.payoutSplit = "Division";
    vm.showFilters = true;
    vm.workOrderDivisionPayoutViewMode = "Summary";
    vm.workOrderDivisionPayouts;
    vm.rogersDivisionID = 35;
    vm.icdCorporationPageSize = 2000;
    vm.anyAdjustmentModified = false;
    vm.onCancelJob = onCancelJob;
    vm.onViewDetails = onViewDetails;
    vm.subscription;



    function onViewDetails({ job }) {
        job.active = true;
        $uibModal.open({
            ...RogersReportJobDetailsModal,
            resolve: {
                report: () => job
                //this.$q.all(!job.IcdCorporations ? [] : job.IcdCorporations.map(id =>
                //// Use list response to reduce data draw. TODO: Support multi-ID filter in list API
                //this.icdCorporationService.retrieveIcdCorporations({ IcdCorporationID: id })
                //    .then(corporations => corporations[0].ClientName)
                //    // In case of failed lookups, include the ID directly.
                //    .catch(_ => id)))
                //.then(icdCorporations => ({
                //    ...job,
                //    IcdCorporations: icdCorporations,
                //    ReportArguments: !job.ReportArguments ? [] : Object.keys(job.ReportArguments)
                //        .map(name => ({
                //            name,
                //            value: job.ReportArguments[name]
                //        }))
                //}))
            }
        }).result.catch(() => { }).then(() => job.active = false);
    }

    function onCancelJob({ job }) {
    }

    function onInit() {
        const initialDataLoaded = loadInitialData();
        /*var query = new */

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError($q.all([initialDataLoaded]), "Initial load failed"));
    }

    function onAddWorkOrder() {
        $uibModal.open({
            component: "apexEditWorkOrderModal",
            resolve: {
                workOrder: function () {
                    return { ProductOrders: [] };
                }
            },
            windowClass: 'xx-dialog pagespinner',
            size: 'xl',
            backdrop: 'static'
        });
    }

    function onPostPayout() {
        // Load work orders matching the current page filters.
        if (!vm.payoutReport) {
            return;
        }
        let productOrderPayouts;
        switch (vm.filters.Division.Id) {
            case divisionService.divisionIDs.Rogers:
                productOrderPayouts = vm.payoutReport;
                break;
            default:
                alert("Posting not implemented for the selected division.");
                break;
        }


        // Show a modal to confirm posting the payouts loaded using the current filters.
        $uibModal.open({
            component: "apexPostWorkOrderPayoutModal",
            resolve: {
                IcdCorporation: vm.filters.IcdCorporation,
                Division: vm.filters.Division,
                productOrderDivisionPayouts: function () {
                    return productOrderPayouts;
                },
                save: function () {
                    return function (request) {
                        const query = {};
                        if (vm.filters.Division) {
                            query.DivisionID = vm.filters.Division.Id;
                        }
                        if (vm.filters.IcdCorporation) {
                            query.IcdCorporationID = vm.filters.IcdCorporation.Id;
                        }
                        const response = postedPayoutService.postPayouts({
                            PostedDate: request.PostedDate ? moment(request.PostedDate).format("YYYY-MM-DD") : null,
                            PayrollDate: request.PayrollDate ? moment(request.PayrollDate).format("YYYY-MM-DD") : null,
                            ProductOrders: request.ProductOrders,
                            MergePreviouslyPosted: request.MergePreviouslyPosted,
                            PreventDescendingPayout: request.PreventDescendingPayout,
                            ...query
                        })
                            .then(onRefreshDataInBackground);
                        utilityService.showLoadingUntilResolved(
                            utilityService.alertOnError(response, "Posting Payout failed"));
                        return response;
                    };
                }
            },
            windowClass: 'xx-dialog pagespinner',
            size: 'xl',
            backdrop: 'static'
        });
    }

    function onRefreshData() {
        const dataLoaded = loadPayoutReport();

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(dataLoaded, "Refreshing data failed"));
    }

    function onRefreshDataInBackground() {
        const dataLoaded = refreshPayoutReport();

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(dataLoaded, "Refreshing data failed"));
    }

    /**
     * Export the details based on the current query parameters.
     */
    function onExport() {
        const query = {
            DivisionID: vm.filters.Division ? vm.filters.Division.Id : null,
            IcdCorporationID: vm.filters.IcdCorporation ? vm.filters.IcdCorporation.Id : null,
            StartDate: vm.filters.StartDate ? kendo.format("{0:yyyy-MM-dd}", vm.filters.StartDate) : null,
            EndDate: vm.filters.EndDate ? kendo.format("{0:yyyy-MM-dd}", vm.filters.EndDate) : null
        };
        if (vm.filters.hidePosted) {
            query.ShowPosted = false;
        }
        if (vm.filters.hideLocked) {
            query.ShowUnlocked = true;
        }
        const queryString = utilityService.queryStringify(query);
        if (query.DivisionID === divisionService.divisionIDs.Rogers) {
            window.location.href = apexApiUrl + "reports/rogers/live-payout-report.xlsx" + queryString;
        } else {
            alert("Report not implemented");
        }
    }

    /**
     * Export the details based on the current query parameters.
     */
    function onExportBackground() {
        const query = {
            DivisionID: vm.filters.Division ? vm.filters.Division.Id : null,
            IcdCorporationID: vm.filters.IcdCorporation ? vm.filters.IcdCorporation.Id : null,
            StartDate: vm.filters.StartDate ? kendo.format("{0:yyyy-MM-dd}", vm.filters.StartDate) : null,
            EndDate: vm.filters.EndDate ? kendo.format("{0:yyyy-MM-dd}", vm.filters.EndDate) : null
        };
        if (vm.filters.hidePosted) {
            query.ShowPosted = false;
        }
        if (vm.filters.hideLocked) {
            query.ShowUnlocked = true;
        }
        const queryString = utilityService.queryStringify(query);
        if (query.DivisionID === divisionService.divisionIDs.Rogers) {
            window.location.href = apexApiUrl + "reports/rogers/create-job-live-payout-report" + queryString;
        } else {
            alert("Report not implemented");
        }
    }

    function onChangeDivision() {

        const icdCorporationsLoaded = loadIcdCorporations();

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(icdCorporationsLoaded, "Loading corporation failed"));
    }

    function onChangeAdjustmentAmount(updatedPayout) {
        vm.anyAdjustmentModified = true;
        // The mutated payout is a clone. Update the "real" payout passed to the view as well.
        const payout = vm.payoutReport.find(item => item.ProductOrderID === updatedPayout.ProductOrderID);
        if (payout) {
            payout._pristineAdjustment = updatedPayout.InnovageRogersAdjustmentAmount;
            payout.IsAdjustmentAmountModified = true;
            payout.InnovageRogersAdjustmentAmount = updatedPayout.InnovageRogersAdjustmentAmount;
        }
    }

    function loadIcdCorporations() {
        if (!vm.filters.Division || !vm.filters.Division.Id) {
            vm.icdCorporations = [];
            vm.icdCorporation = null;
            return $q.when();
        }
        icdCorporationService.retrieveIcdCorporations({
            DivisionID: vm.filters.Division.Id,
            PageSize: vm.icdCorporationPageSize,
            CheckRCNCPO: true
        })
            .then(function (icdCorporations) {
                icdCorporations.forEach(formatIcdCorporation);
                vm.icdCorporations = icdCorporations.sort(function (a, b) {
                    return a.OwnerClientName < b.OwnerClientName ? -1 : 1;
                });
                return icdCorporations;
            });
    }

    function loadInitialData() {
        const divisionsLoaded = divisionService.retrieveDivisions()
            .then(function (divisions) {
                return divisions.filter(function (division) {
                    return !!division.LeadsPolicy;
                });
            })
            .then(function (divisions) {
                vm.divisions = divisions.sort(function (a, b) {
                    if (a.Name < b.Name) {
                        return -1;
                    } else if (a.Name > b.Name) {
                        return 1;
                    }
                    // Fall back into ID comparison if names are the same.
                    return a.Id < b.Id ? -1 : 1;
                });
                return divisions;
            })
            .then(function (divisions) {
                // Pre-select initial division if there is only 1.
                if (divisions.length === 1) {
                    vm.filters.Division = divisions[0];
                }
                return divisions;
            });
        const subscribedToJobs = rogersPayoutReportService.retrieveRogersLivePayoutReportJobs().then(data => {
            vm.jobs = data;
        })
        const ownersLoaded = divisionsLoaded.then(function () {
            if (vm.filters.Division) {
                return icdCorporationService.retrieveIcdCorporations({
                    DivisionID: vm.filters.Division.Id,
                    PageSize: vm.icdCorporationPageSize
                });
            }
        }).then(function (icdCorporations) {
            return loadIcdCorporations();
        });

        return $q.all([divisionsLoaded, ownersLoaded, subscribedToJobs]);
    }

    function onSaveAdjustments() {
        const modifiedAdjsutments = vm.payoutReport.filter(function (payout) {
            return payout.IsAdjustmentAmountModified;
        });
        const request = productOrderAdjustmentService.bulkUpsertProductOrderAdjustments(
            modifiedAdjsutments.map(mapModifiedAdjustment))
            .then(onRefreshDataInBackground);

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(request, "Initial load failed"));
    }

    function mapModifiedAdjustment(adjustment) {
        const request = {
            ProductOrderID: adjustment.ProductOrderID,
            ProductOrderAdjustmentID: adjustment.ProductOrderAdjustmentID ?
                adjustment.ProductOrderAdjustmentID : 0,
            AdjustmentAmount: adjustment.InnovageRogersAdjustmentAmount,
            Type: 'InnovageRogersAmount'
        };
        return request;
    }

    function onCancelAdjustments() {
        for (const payout of vm.payoutReport.filter(p => p.IsAdjustmentAmountModified)) {
            payout.IsAdjustmentAmountModified = false;
            payout.InnovageRogersAdjustmentAmount = payout._pristineAdjustment;
        }
        vm.anyAdjustmentModified = false;
        vm.payoutReport = Array.from(vm.payoutReport); // Replace the reference to signal a component update.
    }

    function loadPayoutReport() {
        if (!vm.filters.Division) {
            // No data to load.
            vm.payoutReport = null;
            return $q.when();
        }

        switch (vm.filters.Division.Id) {
            case divisionService.divisionIDs.Rogers:
                // Load Rogers live payout amounts as report.
                const query = {
                    DivisionID: vm.filters.Division ? vm.filters.Division.Id : null,
                    IcdCorporationID: vm.filters.IcdCorporation ? vm.filters.IcdCorporation.Id : null,
                    StartDate: vm.filters.StartDate ? kendo.format("{0:yyyy-MM-dd}", vm.filters.StartDate) : null,
                    EndDate: vm.filters.EndDate ? kendo.format("{0:yyyy-MM-dd}", vm.filters.EndDate) : null
                };

                if (vm.filters.hidePosted) {
                    // If true, only posted work orders would be included, so only set this argument when the filter is checked.
                    query.ShowPosted = false;
                }

                return rogersPayoutReportService.retrieveRogersLivePayoutReport(query)
                    .then(function (payoutReport) {
                        // Compute totals for the work orders.
                        vm.payoutReport = payoutReport;
                        // vm.pristinePayoutReport = angular.copy(vm.payoutReport);
                        return payoutReport;
                    });
            default:
                alert("Report format not defined.");
                break;

        }
    }

    function refreshPayoutReport() {
        if (!vm.filters.Division) {
            // No data to load.
            vm.payoutReport = null;
            return $q.when();
        }

        switch (vm.filters.Division.Id) {
            case divisionService.divisionIDs.Rogers:
                // Load Rogers live payout amounts as report.
                const query = {
                    DivisionID: vm.filters.Division ? vm.filters.Division.Id : null,
                    IcdCorporationID: vm.filters.IcdCorporation ? vm.filters.IcdCorporation.Id : null,
                    StartDate: vm.filters.StartDate ? kendo.format("{0:yyyy-MM-dd}", vm.filters.StartDate) : null,
                    EndDate: vm.filters.EndDate ? kendo.format("{0:yyyy-MM-dd}", vm.filters.EndDate) : null
                };

                if (vm.filters.hidePosted) {
                    // If true, only posted work orders would be included, so only set this argument when the filter is checked.
                    query.ShowPosted = false;
                }
                //if (true) {
                //    vm.subscription = interval(5000).pipe( // Change the interval as needed
                //        exhaustMap(() => getLoadJobData(query, 'c0652434-7275-4758-b009-7d8731598cc0'))
                //    ).subscribe(
                //        payoutReport => {
                //            //this.data = response;
                //            console.log(payoutReport);
                //            // Add your condition here to unsubscribe
                //            if (payoutReport) {
                //                vm.subscription.unsubscribe();
                //                vm.payoutReport = payoutReport;
                //                // vm.pristinePayoutReport = angular.copy(vm.payoutReport);
                //                return payoutReport;
                //            }
                //        },
                //        error => {
                //            console.error('There was an error!', error);
                //        }
                //    );

                //}
                //else {
                return rogersPayoutReportService.createRogersRefreshReportJob(query)
                    .then(function (payoutReport) {
                        utilityService.showLoading();
                        // Compute totals for the work orders.
                        //vm.payoutReport = payoutReport;
                        // vm.pristinePayoutReport = angular.copy(vm.payoutReport);
                        if (payoutReport && payoutReport.Id != null) {
                            vm.subscription = interval(5000).pipe( // Change the interval as needed
                                exhaustMap(() => getLoadJobData(query, payoutReport.Id))
                            ).subscribe(
                                response => {
                                    //this.data = response;
                                    console.log(response);
                                    // Add your condition here to unsubscribe
                                    if (response) {
                                        utilityService.hideLoading();
                                        vm.subscription.unsubscribe();
                                        vm.payoutReport = response;
                                        // vm.pristinePayoutReport = angular.copy(vm.payoutReport);
                                        return payoutReport;

                                    }
                                },
                                error => {
                                    utilityService.hideLoading();
                                    console.error('There was an error!', error);
                                }
                            );
                        } else {
                            utilityService.hideLoading();
                            alert("Job creation error");
                        }

                    });
            /*}*/
            default:
                alert("Report format not defined.");
                break;

        }
    }

    function getLoadJobData(query, jobId) {
        return rogersPayoutReportService.retrieveRogersRefreshReportData(query, jobId)
            .then(function (result) {
                return result;
            });
    }

    function createPayoutReportInBackground() {
        if (!vm.filters.Division) {
            // No data to load.
            return $q.when();
        }

        switch (vm.filters.Division.Id) {
            case divisionService.divisionIDs.Rogers:
                // Load Rogers live payout amounts as report.
                const query = {
                    DivisionID: vm.filters.Division ? vm.filters.Division.Id : null,
                    IcdCorporationID: vm.filters.IcdCorporation ? vm.filters.IcdCorporation.Id : null,
                    StartDate: vm.filters.StartDate ? kendo.format("{0:yyyy-MM-dd}", vm.filters.StartDate) : null,
                    EndDate: vm.filters.EndDate ? kendo.format("{0:yyyy-MM-dd}", vm.filters.EndDate) : null
                };

                if (vm.filters.hidePosted) {
                    // If true, only posted work orders would be included, so only set this argument when the filter is checked.
                    query.ShowPosted = false;
                }
                utilityService.showLoading();
                return rogersPayoutReportService.createRogersLivePayoutReportJob(query)
                    .then(function (payoutReport) {
                        loadInitialData();
                        utilityService.hideLoading();
                        if (payoutReport && payoutReport.Id != null) {
                            vm.subscription = interval(10000).pipe(take(10),
                                exhaustMap(() => rogersPayoutReportService.retrieveRogersLivePayoutReportJobs())
                            ).subscribe(
                                jobs => {
                                    //this.data = response;
                                    console.log(jobs);
                                    vm.jobs = jobs;
                                    var active = jobs.filter(function (item) {
                                        return item.Id === payoutReport.Id;
                                    })[0];
                                    // Add your condition here to unsubscribe
                                    if (active == null || (active != null && active.JobStatus !== 'Queued' && active.JobStatus !== 'Processing')) {
                                        utilityService.hideLoading();
                                        vm.subscription.unsubscribe();
                                        // vm.pristinePayoutReport = angular.copy(vm.payoutReport);
                                        return payoutReport;

                                    }
                                },
                                error => {
                                    utilityService.hideLoading();
                                    console.error('There was an error!', error);
                                }
                            );
                        } else {
                            utilityService.hideLoading();
                            alert("Job creation error");
                        }
                        return payoutReport;
                    });
            default:
                alert("Report format not defined.");
                break;

        }
    }

    function formatIcdCorporation(icdCorporation) {
        icdCorporation.OwnerClientName = icdCorporation.Owner + " - " + icdCorporation.ClientName;
    }
}
